import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-row-wrapper',
  templateUrl: './table-row-wrapper.component.html',
  styleUrls: ['./table-row-wrapper.component.scss']
})
export class TableRowWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
